import React from "react";
import StickIcon from "@material-ui/icons/InfoOutlined";
import EditIcon from "@material-ui/icons/EditOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import locale from "@bonliva-crm/locale";
import {
  EventLog_AccommodationEventFragment as Event,
  AccommodationEventLog_Pin as pinEvent,
  AccommodationEventLog_Delete as deleteEvent
} from "@graphql";
import { ButtonOptions, FloatingMenu } from "@components/FloatingMenu";

type Props = {
  event: Event;
  onEdit: () => void;
  className?: string;
};

export function AccommodationEventFloatingMenu(props: Props) {
  const { className, event } = props;
  const buttons: ButtonOptions[] = [];

  if (event.CanPin) {
    buttons.push({
      key: "pin-log-item",
      icon: <StickIcon fontSize="inherit" />,
      onClick: () =>
        pinEvent.func({
          eventId: event._id
        }),
      title: locale.Sticky,
      titleDisabled: locale.NoPermissions,
      disabled: false
    });
  }

  if (event.CanEdit) {
    buttons.push({
      key: "edit-log-item",
      icon: <EditIcon fontSize="inherit" />,
      onClick: props.onEdit,
      title: locale.Edit,
      titleDisabled: locale.NoPermissions,
      disabled: false
    });
  }

  if (event.CanDelete) {
    buttons.push({
      key: "delete-log-item",
      icon: <DeleteIcon fontSize="inherit" />,
      onClick: () => deleteEvent.func({ eventId: event._id }),
      title: locale.Delete,
      titleDisabled: locale.NoPermissions,
      disabled: !event.CanDelete
    });
  }

  return <FloatingMenu className={className} buttons={buttons} />;
}
